import React from 'react';
import styled from 'styled-components';
import { cms } from 'assets/cms';
import {
  HeadlineOne,
  HeadlineTwo,
  Paragraph,
} from 'components/atoms/SectionWrapper.style';

const IconsContact = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-top: 20px;
  @media ${({ theme }) => theme.media.laptop} {
    flex-direction: row;
  }
  div {
    margin: 10px auto;
    padding: 10px;

    img {
      height: 50px;
    }
    span {
      font-weight: bold;
    }

    @media ${({ theme }) => theme.media.tablet} {
      margin: 10px auto;
    }
  }
  @media ${({ theme }) => theme.media.tablet} {
    flex-direction: column;
  }
`;

const Breakdown = styled.div`
  @media ${({ theme }) => theme.media.laptop} {
    display: flex;
    margin: 0 auto;
    margin-bottom: 60px;
  }
`;

const Left = styled.div`
  @media ${({ theme }) => theme.media.laptop} {
    /* border-right: solid 1px black;
    width: 600px;
    flex-direction: column; */
  }
`;

const Right = styled.div`
  @media ${({ theme }) => theme.media.laptop} {
    width: 50%;
  }
`;

const ImgWrapperProjekt = styled.div`
  margin-top: 15px;
  img {
    height: 40px;
  }
`;

const WrappersLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ImgWrapperEle = styled.div`
  margin-top: 15px;
  margin-left: 35px;
  img {
    height: 33px;
  }
`;
const ImgWrapperOze = styled.div`
  img {
    height: 55px;
  }
`;

const RightTablet = styled.div``;

const ContactIconsWrapper = () => (
  <Breakdown>
    <Left>
      {/* <HeadlineTwo>Biuro:</HeadlineTwo> */}
      <ImgWrapperProjekt>
        <img src={cms.logo.proj} />
      </ImgWrapperProjekt>
      <IconsContact>
        <div>
          <img src={cms.icons.phone} />

          <Paragraph>
            <span>+48 535-061-637</span>
          </Paragraph>
        </div>
        <div>
          <img src={cms.icons.email} />
          <Paragraph>
            <span>elgreen@elgreen.pl</span>
          </Paragraph>
        </div>
        <div>
          <img src={cms.icons.gps} />
          <Paragraph>
            <span>Rdestowa 51, 81-577 Gdynia</span>
          </Paragraph>
        </div>
      </IconsContact>
    </Left>
    {/* 
    <Right>
      <WrappersLogo>
        <ImgWrapperOze>
          <img src={cms.logo.oze} />
        </ImgWrapperOze>
        <ImgWrapperEle>
          <img src={cms.logo.ele} />
        </ImgWrapperEle>
      </WrappersLogo>
      <RightTablet></RightTablet>
      <IconsContact>
        <div>
          <img src={cms.icons.phone} />
          <Paragraph>
            <span>+48 509-722-909</span>
          </Paragraph>
          <Paragraph>
            <span>+48 514 254 267</span>
          </Paragraph>
        </div>
        <div>
          <img src={cms.icons.email} />
          <Paragraph>
            <span>tm@elgreen.pl</span>
          </Paragraph>
          <Paragraph>
            <span>kz@elgreen.pl</span>
          </Paragraph>
        </div>
        <div>
          <img src={cms.icons.gps} />
          <Paragraph>
            <span>Rdestowa 51, 81-577 Gdynia</span>
          </Paragraph>
        </div>
      </IconsContact>
    </Right> */}
  </Breakdown>
);

export default ContactIconsWrapper;
